import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

Swiper.use([Navigation]);

/* Swiper: turn `.carousel-apps` with direct `.card-item` children into a slider */
(function initCarouselApps() {

  document.querySelectorAll('.carousel-apps').forEach(function (container) {
    if (container.classList.contains('swiper-initialized')) return;

    container.classList.add('swiper');

    var wrapper = document.createElement('div');
    wrapper.className = 'swiper-wrapper';

    Array.from(container.children).forEach(function (child) {
      if (child.classList.contains('card-item')) {
        child.classList.add('swiper-slide');
        wrapper.appendChild(child);
      }
    });

    if (!wrapper.children.length) return;

    container.appendChild(wrapper);

    var swiperSection = container.closest('section, .swiper-section, .carousel-section') || container.parentElement;
    var prevBtn = swiperSection.querySelector('.app-swiper-prev');
    var nextBtn = swiperSection.querySelector('.app-swiper-next');

    if (!prevBtn || !nextBtn) {
      var controlsContainer = container.nextElementSibling;
      if (controlsContainer && controlsContainer.classList.contains('swiper-controls')) {
        prevBtn = controlsContainer.querySelector('.app-swiper-prev');
        nextBtn = controlsContainer.querySelector('.app-swiper-next');
      }
    }

    var defaultBreakpoints = {
      100:  { slidesPerView: 1.15, spaceBetween: 10 },
      576:  { slidesPerView: 1.8, spaceBetween: 30 },
      992:  { slidesPerView: 1.2, spaceBetween: 30 },
      1200: { slidesPerView: 1.8, spaceBetween: 30 },
      1600: { slidesPerView: 2.3, spaceBetween: 30 }
    };

    var altBreakpoints = {
      100:  { slidesPerView: 1.2, spaceBetween: 30 },
      576:  { slidesPerView: 2.3, spaceBetween: 30 },
      992:  { slidesPerView: 3.2, spaceBetween: 30 },
      1200: { slidesPerView: 3.2, spaceBetween: 30 },
      1600: { slidesPerView: 4.2, spaceBetween: 30 }
    };

    var chosenBreakpoints = container.classList.contains('breakpoints-alt')
        ? altBreakpoints
        : defaultBreakpoints;

    new Swiper(container, {
      loop: false,
      speed: 600,
      spaceBetween: 16,
      slidesPerView: 1,
      slidesOffsetAfter: 30,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn
      },
      breakpoints: chosenBreakpoints
    });
  });
})();